var $1133d3628ea10323$exports = {};
$1133d3628ea10323$exports = {
    "invalidSelection": (args, formatter)=>`Valitud ${formatter.plural(args.selectedCount, {
            one: `kuup\xe4ev`,
            other: `kuup\xe4evad`
        })} pole saadaval.`
};


export {$1133d3628ea10323$exports as default};
//# sourceMappingURL=et-EE.module.js.map
